import type { PreloadedQuery } from 'react-relay';
import QUERY, {
	type EditPermissionSchemesQuery,
} from '@jira/permissions-administration__pages-edit-permission-scheme/src/ui/__generated__/EditPermissionSchemesQuery.graphql';
// eslint-disable-next-line jira/import-whitelist
import { createRelayResource } from '@jira/platform__graphql-relay-utils/src/services/resources/index.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import type { RouteResource } from '@atlassian/react-resource-router';

const RESOURCE_TYPE_EDIT_PERMISSION_SCHEME_PAGE = 'EDIT_PERMISSION_SCHEME_PAGE';

export const editPermissionSchemePageResource: RouteResource<
	PreloadedQuery<EditPermissionSchemesQuery, Record<string, unknown>>
> = createRelayResource<EditPermissionSchemesQuery>({
	type: RESOURCE_TYPE_EDIT_PERMISSION_SCHEME_PAGE,
	getQuery: ({ match }, { tenantContext }) => ({
		parameters: QUERY,
		variables: {
			// To Do: use ari-typescript library once it is approved
			// https://hello.atlassian.net/wiki/spaces/TGR/pages/1374189554/Dependency+review+atlassian+ari
			schemeId: `ari:cloud:jira:${tenantContext.cloudId}:permission-scheme/activation/${
				tenantContext.activationId
			}/${String(match.params.schemeId)}`,
			first: 50,
			isGrantsPerPermissionLimitEnabled: fg('slt1_1018-use-limit-provider-for-grants-permission'),
		},
		options: { fetchPolicy: 'network-only' },
	}),
});
